import {
  COMING_SOON,
  NEW_EDITION,
  NO_LONGER_FOR_SALE,
  NOT_SOLD_ONLINE,
  OUT_OF_STOCK,
  SOLD_OUT,
} from '@ori/presentation-components';

export const SEARCH_PREVIEW_PRODUCT_PRODUCT_INFO_LABEL = 'search-preview-product-product-info-label';

export const allowedDealLabels = [NEW_EDITION];

export const allowedNegativePpaLabels = [NOT_SOLD_ONLINE, OUT_OF_STOCK, SOLD_OUT, COMING_SOON, NO_LONGER_FOR_SALE];
